export * from './store-product-detail.page'